import axios from 'axios';

import { EDX_API_ENDPOINTS } from 'config';
import { getPanelLmsBaseUrl } from 'helpers';

export function UpdateCookie(params) {
  const url = `${getPanelLmsBaseUrl()}${EDX_API_ENDPOINTS.COOKIE_REFRESH}`;
  const requestOptions = {
    method: 'GET',
    withCredentials: true,
    params: params,
    url
  };
  return axios(requestOptions);
}
